const ResourcesIcon = ({ fill = "#343741" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.60938 3.375H3.23438L3.23437 6.75H6.60938V3.375ZM3.23438 2.25C2.61305 2.25 2.10938 2.75368 2.10938 3.375V6.75C2.10938 7.37132 2.61305 7.875 3.23437 7.875H6.60938C7.2307 7.875 7.73438 7.37132 7.73438 6.75V3.375C7.73438 2.75368 7.2307 2.25 6.60938 2.25H3.23438Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.60938 11.25H3.23438L3.23437 14.625H6.60938V11.25ZM3.23438 10.125C2.61305 10.125 2.10938 10.6287 2.10938 11.25V14.625C2.10938 15.2463 2.61305 15.75 3.23437 15.75H6.60938C7.2307 15.75 7.73438 15.2463 7.73438 14.625V11.25C7.73438 10.6287 7.2307 10.125 6.60938 10.125H3.23438Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4844 3.375H11.1094V6.75H14.4844V3.375ZM11.1094 2.25C10.4881 2.25 9.98438 2.75368 9.98438 3.375V6.75C9.98438 7.37132 10.4881 7.875 11.1094 7.875H14.4844C15.1057 7.875 15.6094 7.37132 15.6094 6.75V3.375C15.6094 2.75368 15.1057 2.25 14.4844 2.25H11.1094Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4844 11.25H11.1094V14.625H14.4844V11.25ZM11.1094 10.125C10.4881 10.125 9.98438 10.6287 9.98438 11.25V14.625C9.98438 15.2463 10.4881 15.75 11.1094 15.75H14.4844C15.1057 15.75 15.6094 15.2463 15.6094 14.625V11.25C15.6094 10.6287 15.1057 10.125 14.4844 10.125H11.1094Z"
        fill={fill}
      />
    </svg>
  );
};

export default ResourcesIcon;
